import React, { useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { SHOW_SNACKBAR } from '../../utils/types';

function AssignChat({ onAssignTicket, contects, agents, agentGroup }) {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [searchText, setSearchText] = useState();
    const [selectedAgent, setSelectedAgent] = useState({});

    return (
        <div className="gap-2 my-2 px-7">
            <input type="search" placeholder={t("Search Agents and Groups")} className="border border-gray-300 rounded-md py-1 text-[14px] w-[100%]"
                onChange={(e) => setSearchText(e.target.value?.toLowerCase())} />
            <div className='gap-2 mt-3 max-h-[60vh]'>
                <div className='py-1 bg-gray-100 rounded-[4px] px-2'>
                    <label className='text-[16px] text-gray-500'>{t("Agent")}</label>
                </div>
                <hr />
                <div className='ml-4 mt-2'>
                    {agents?.filter(f => !searchText || f.name?.toLowerCase()?.includes(searchText))?.map((agent, index) => (
                        <label key={index} className='flex items-center gap-2 cursor-pointer mt-2' htmlFor={`agent${index}`}>
                            <input className="w-4 h-4 text-theme bg-gray-300 shadow-input border-none focus:ring-transparent focus:ring-none"
                                type='radio' id={`agent${index}`} name='agent'
                                checked={selectedAgent?.agentId === agent.uid && selectedAgent?.type === 'agent'}
                                onChange={(e) => {
                                    if (e.target.checked) {
                                        setSelectedAgent({ ...selectedAgent, agentId: agent.uid, type: 'agent' });
                                    } else {
                                        delete selectedAgent.agentId;
                                        delete selectedAgent.type;
                                    }
                                }}
                            />
                            <label htmlFor={`agent${index}`} className='text-[14px] text-gray-700'>{agent.name}</label>
                        </label>
                    ))}
                </div>
                <div className='py-1 bg-gray-100 rounded-[4px] px-2 mt-3'>
                    <label className='text-[16px] text-gray-500'>{t("Group")}</label>
                </div>
                <hr />
                <div className='ml-4 mt-2 pb-2'>
                    {agentGroup?.filter(f => !searchText || f.name?.toLowerCase()?.includes(searchText))?.map((group, index) => (
                        <label key={index} className='flex items-center gap-2 cursor-pointer' htmlFor={`group${index}`}>
                            <input className="w-4 h-4 text-theme bg-gray-300 shadow-input border-none focus:ring-transparent focus:ring-none"
                                type='radio' id={`group${index}`} name='agent'
                                checked={selectedAgent?.groupId === group.id && selectedAgent?.type === 'group'}
                                onChange={(e) => {
                                    if (e.target.checked) {
                                        setSelectedAgent({ ...selectedAgent, groupId: group.id, groupName: group.name, type: 'group', memberIds: group.memberIds });
                                    } else {
                                        delete selectedAgent.groupName;
                                        delete selectedAgent.groupId;
                                        delete selectedAgent.type;
                                        delete selectedAgent.memberIds;
                                    }
                                }}
                            />
                            <label htmlFor={`group${index}`} className='text-[14px] text-gray-700'>{group.name}</label>
                        </label>
                    ))}
                </div>
            </div>
            <button type='button' onClick={() => {
                const users = selectedAgent?.type === 'agent' ? [selectedAgent.agentId] : selectedAgent?.memberIds || [];
                if (users.length === 0) {
                    dispatch({ type: SHOW_SNACKBAR, payload: { type: "error", message: t("Please select an agent or group to assign the ticket."), open: true } });
                    return;
                }
                if (contects?.length === 0) {
                    dispatch({ type: SHOW_SNACKBAR, payload: { type: "error", message: t("Please select at least one ticket to assign."), open: true } });
                    return;
                }
                if (selectedAgent?.type === 'group' && !selectedAgent?.memberIds) {
                    dispatch({ type: SHOW_SNACKBAR, payload: { type: "error", message: t("Please select a group member to assign the ticket."), open: true } });
                    return;
                }
                if (selectedAgent?.type === 'group') {
                    onAssignTicket({ "ids": contects?.map(m => m?.id), "assigned_users": users, "assigned_group": { groupId: selectedAgent.groupId, groupName: selectedAgent.groupName } });
                } else {
                    onAssignTicket({ "ids": contects?.map(m => m?.id), "assigned_users": users, "assigned_group": {} });
                }
            }} className="w-full mb-2 mt-2 bg-theme text-white rounded-[6px] h-[40px] px-[12px] py-[4px]">
                {t('Assign')}
            </button>
        </div>
    )
}

export default AssignChat